import { styled } from '@linaria/react'
import { FormSC } from 'blocks/Form'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { LAYOUT } from 'vars/layout-settings'
import { MEDIA } from 'vars/media'
import { PositioningBlockSC } from '../PositioningBlock.styled'

export const HybridSearchStickyPositioningBlockSC = styled(PositioningBlockSC)`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_50});
  padding: var(${FIXED_INDENTS.INDENT_50}) 0;

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_60});
    padding: var(${FIXED_INDENTS.INDENT_60}) 0;
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_80});
    padding: var(${FIXED_INDENTS.INDENT_80}) 0;
  }

  ${FormSC} {
    padding: 0 var(${LAYOUT.HorizontalPaddings});
  }
`
